import { ListFilter } from 'lucide-react'
import { Button } from '../Button'
import { MouseEventHandler } from 'react'
import { useTranslation } from 'react-i18next'

export type FilterDrawerButtonProps = {
  onClick: MouseEventHandler<HTMLButtonElement>
}
export function FilterDrawerButton (props: FilterDrawerButtonProps) {
  const { onClick } = props
  const { t } = useTranslation()
  return (
    <span
      className={'tooltip tooltip-top pl-1 before:w-[200px] before:content-[attr(data-tip)]'}
      data-tip={t('filters:Filters')}
    >
      <Button size='sm' className='bg-white' onClick={onClick}>
        <ListFilter size={12} />
      </Button>
    </span>
  )
}
